

















// Copyright © 2021 Move Closer

import { defineComponent, SetupContext } from '@vue/composition-api'

import { SwitchesProps } from './Switch.contracts'
import { useSwitches, useSwitchesProps } from './Switch.hook'

/**
 * @author Olga Milczek <olga.milczek@movecloser.pl>
 */
export const DashmixSwitch = defineComponent({
  name: 'DashmixSwitch',
  props: useSwitchesProps,
  emits: ['onChange'],

  setup (props: SwitchesProps, ctx: SetupContext) {
    return useSwitches(props, ctx)
  }
})

export default DashmixSwitch
